<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true" v-on:closemodal="assignCopy">
        <div slot="title">
            <h2>Price Settings</h2>
        </div>

        <div slot="body">
            <div v-if="isLoading" class="m-4 text-center">
                <loader />
            </div>

            <div v-else>
                <div class="bg-color-1 lightest text-right p-4" v-if="!isPricePerGroup">
                    <div class="text-uppercase" v-if="getProductEditPriceData.audienceType">
                        Total per {{audienceIdToName(getProductEditPriceData.audienceType)}}
                    </div>

                    <div class="total-value">
                        {{totalPVP}} €
                    </div>
                </div>
                
                <div class="col-sm-5 pl-5 pt-2">
                    <div class="my-2">
                        <label class="full">Component Type</label>
                    </div>

                    <div class="d-flex">
                        <v-select
                            v-model="descriptionAudienceTypes"
                            :class="{'notAllowed': getProductEditPriceData.isDisabled}"
                            :options="types"
                            label="description"
                            placeholder="-Search type-"
                            @input="updateComponentRuleType(descriptionAudienceTypes)"
                            :disabled="getProductEditPriceData.isDisabled">
                        </v-select>
                        
                        <i  class="d-flex align-items-center ml-3 color-6 fa fa-info-circle fs-large" 
                            v-tooltip="'Fixed decomposed prices are only available when there is no rule groups in product'"
                            v-if="hasRuleGroupsAssociated"></i>   
                    </div>
                </div>
                
                <div class="col-sm-5 pl-5 mt-3 total-price-min-height" v-if="getProductEditPriceData.componentRuleType != 0 && !isPricePerGroup">
                    <div class="my-2">
                        <label class="bold">Total Price <span v-if="getProductEditPriceData.value == null" class="color-6 bold ml-1">*</span></label>
                    </div>

                    <div class="d-flex">
                        <input 
                            type="number" 
                            style="width: 5rem;"
                            v-model.number="getProductEditPriceData.value"
                            @change="updateValuePrice()"
                            class="glued-right py-[1.5px]"
                            :disabled="getProductEditPriceData.isDisabled"
                        > 
                        <div class="glued-left py-[1.5px]">€</div>
                    </div>

                    
                    <div v-if="hasServiceValueError" class="mt-1 error text-nowrap">
                        <span>The service value cannot be equal to or less than 0€</span>
                    </div>
                </div>

                <div class="px-5 py-4">
                    <split-price-editor @row-is-ready-to-save="isReadyToSave($event)" :isToLoadUpdateRowToStore="isToLoadUpdateRowToStore" :disabled="getProductEditPriceData.isDisabled" :priceObj="getProductEditPriceData" :componentRuleType="componentRuleType" :isPricePerGroup="isPricePerGroup"></split-price-editor>
                </div>
            </div>
        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-end">
            <div>
                <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                <button type="button" class="btn ok wider" :disabled="!isReadyToBeSaved && getProductEditPriceData.componentRuleType !== 1 || getProductEditPriceData.isDisabled || hasServiceValueError" @click="save">Save</button>
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Modal from './Modal'
    import extendedVSelect from '@/extends/vue-select'
    import { eventHub } from '../../main'
    import SplitPriceEditor from '../../components/inventory/products/SplitPriceEditor'
    import Loader from '@/tools/loaders/loader1'

    export default {
        data() {
            return {
                descriptionAudienceTypes: null,
                isLoadingExtras: false,
                isLoadingAudienceTypes: false,
                priceComponentsCOPY: undefined,
                priceComponentRuleTypeCOPY: undefined,
                isReadyToBeSaved: false,
                isValidationForFixedType:false,
                isValidationForOpenType: false,
                isValidationForPercentType: false,
                isToLoadUpdateRowToStore: false,
                isPricePerGroup: false,
                componentRuleType: null
            }
        },
        created() {
            if (this.getProductEditPriceData.isPricePerGroup) {
                this.isPricePerGroup = true;
            }
            // When componentRuleType = 0 the default type will be percent when price per group
            if (this.getProductEditPriceData.genderPriceType === 3) {
                // Percent type = 1
                this.getProductEditPriceData.componentRuleType = this.getProductEditPriceData.componentRuleType || 1;
            }

            // When componentRuleType = null the default type is fixed
            if (this.getProductEditPriceData.componentRuleType == null) {
                // Fixed type = 0
                this.getProductEditPriceData.componentRuleType = 0;
            }
            // Save a copy of productGenderPriceComponents
            this.priceComponentsCOPY = JSON.parse(JSON.stringify(this.getProductEditPriceData.productGenderPriceComponents));
            // Save a copy of componentRuleType 
            this.priceComponentRuleTypeCOPY = JSON.parse(JSON.stringify(this.getProductEditPriceData.componentRuleType));
            // Save a copy of value
            this.priceComponentsValueCOPY = JSON.parse(JSON.stringify(this.getProductEditPriceData.value));
            this.componentRuleType = this.getProductEditPriceData.componentRuleType;
        },
        updated() {
            // Bus updates "ProductEdit" to update the pricing rows
            eventHub.$emit('forceUpdate');
        },
        methods: {
            ...mapActions([
                'closeModal',
                'updateroductEditPriceData',
            ]), 
            updateComponentRuleType(selectComponentRuleType) {
                // Every time the pricing type changes, 'isToLoadUpdateRowToStore' is updated. 
                // Child component watches this change and triggers 'updateRowToStore', performing validations for each pricing type.
                this.isToLoadUpdateRowToStore = !this.isToLoadUpdateRowToStore;
                
                // Update pricing type
                this.$set(this.getProductEditPriceData, 'componentRuleType', selectComponentRuleType.value);
                this.componentRuleType = selectComponentRuleType.value;

                if (this.getProductEditPriceData.componentRuleType != 2) { 
                    // If pricing type is not 'open', set remainingValue to false, ensuring no service is marked with remainingValue true unless type is 'open'.
                    this.getProductEditPriceData.productGenderPriceComponents.forEach((service) => {
                        service.isRemainingValue = false;
                    })
                }

                // If pricing type is 'percent', set service.value to null to avoid passing existing values from previous 'open' or 'fixed' pricing types.
                if (this.getProductEditPriceData.componentRuleType == 1) {
                    this.getProductEditPriceData.productGenderPriceComponents.forEach((service) => {
                        service.value = null;
                    })
                }
            },
            isReadyToSave(isReady) { 
                this.isValidationForFixedType = isReady;
                this.isValidationForOpenType = isReady;
                this.isValidationForPercentType = isReady;

                if (this.getProductEditPriceData.componentRuleType == 0) {
                    return  this.isReadyToBeSaved = this.isValidationForFixedType;
                } else if (this.getProductEditPriceData.componentRuleType == 1) {
                    return  this.isReadyToBeSaved = this.isValidationForPercentType;
                } else if (this.getProductEditPriceData.componentRuleType == 2) {
                    return  this.isReadyToBeSaved = this.isValidationForOpenType;
                }
            },
            updateValuePrice() {
                this.isToLoadUpdateRowToStore = !this.isToLoadUpdateRowToStore;
            },
            assignCopy() {
                this.getProductEditPriceData.productGenderPriceComponents = this.priceComponentsCOPY;
                this.getProductEditPriceData.componentRuleType = this.priceComponentRuleTypeCOPY;
                this.getProductEditPriceData.value = this.priceComponentsValueCOPY;
            },
            cancel() {
                // Assign the copy of productGenderPriceComponents to the original
                this.getProductEditPriceData.productGenderPriceComponents = this.priceComponentsCOPY;
                
                // Assign the copy of componentRuleType to the original
                this.getProductEditPriceData.componentRuleType = this.priceComponentRuleTypeCOPY;

                // Assign the copy of value to the original
                this.getProductEditPriceData.value = this.priceComponentsValueCOPY;
                this.closeModal();
            },
            save() {
                const decomposedPricesSize = this.getProductEditPriceData.productGenderPriceComponents.length;
                
                if (this.getProductEditPriceData.componentRuleType == 2) {
                    if (decomposedPricesSize === 0 && this.isPricePerGroup) {
                        this.closeModal();
                        return false;
                    }

                    let totalOpenType = 0;
                    let remainingValue = 0;

                    const listOfGrossprices = this.getProductEditPriceData.productGenderPriceComponents.map(service => !service.isRemainingValue && service.component.selectedPrice != null ? parseFloat(service.component.selectedPrice.grossprice) : 0);
                    const sumGrossprices = listOfGrossprices.length > 0 ? listOfGrossprices.reduce((accumulator, currentValue) => accumulator + currentValue, 0) : 0;
                    const remainingService = this.getProductEditPriceData.productGenderPriceComponents.find((service) =>  service.isRemainingValue);

                    if (remainingService) {
                        remainingValue = Math.round(remainingService.value * 100) / 100;
                        totalOpenType = Math.round((remainingValue + sumGrossprices) * 100) / 100;
                    }

                    // If sum of value of remaining item and the sum of grossprices is equal to the definid value, we config the payload
                    if ((totalOpenType == this.getProductEditPriceData.value || totalOpenType == this.getProductEditPriceData.grossprice) && (remainingValue > 0 || this.isPricePerGroup)) { 
                        this.getProductEditPriceData.productGenderPriceComponents.forEach((service) => {
                            service.valueType = 0;
                            if (service.isRemainingValue == true && service.value > 0){
                                service.selectedPrice = null;
                                service.grossprice = null;
                                service.netprice = null;
                                service.component.selectedPrice = null;
                            }

                            // If we have cleared the prop value by changing the type to the percentage type, now we reallocate the value again
                            if (service.component.selectedPrice !== null && !this.isPricePerGroup || this.isPricePerGroup && service.value < 0 && !service.isRemainingValue) {   
                                service.value = service.selectedPrice.value;
                            }
                        })

                        this.closeModal();
                    } else {
                          if (remainingValue < 0) {
                            this.$toasted.error('The value of remaining value item must be greater than 0');
                        } 
                    }
                } else if (this.getProductEditPriceData.componentRuleType == 1) {
                    if (decomposedPricesSize === 0 && this.isPricePerGroup) {
                        this.closeModal();
                        return false;
                    }

                    const listOfPercentValues = this.getProductEditPriceData.productGenderPriceComponents.map(price => parseFloat(price.value)).filter(value => !isNaN(value));
                    const sumPercentValues = listOfPercentValues.length > 0 ? listOfPercentValues.reduce((accumulator, currentValue) => accumulator + currentValue, 0) : 0;

                    // If 100% we config the payload
                    if (sumPercentValues == 100) {
                        this.getProductEditPriceData.productGenderPriceComponents.forEach((service) => {
                            service.selectedPrice = null;
                            service.grossprice = null;
                            service.netprice = null;
                            service.valueType = 1;
                            service.component.selectedPrice = null;
                        })
                        this.closeModal();
                    } else {
                        this.$toasted.error('The sum of percent values must be 100%.');
                    }
                } else if (this.getProductEditPriceData.componentRuleType == 0) {
                    this.getProductEditPriceData.productGenderPriceComponents.forEach((service) => {
                        service.valueType = 0;
                        service.value = service.selectedPrice.value; // If the prop value was cleared by changing to percentage type, reassign the value now.
                    })

                    this.closeModal();
                }
            },
            audienceIdToName(audienceId){
                if (this.audienceTypes) {
                    return this.audienceTypes.filter((audience) => {
                        return audience.id == audienceId;
                    })[0].description;
                }
            },
        },
        computed: {
            ...mapGetters([
                'account',
                'getProductEditPriceData',
                'getClonedItem'
            ]),
            hasServiceValueError() {
                return this.getProductEditPriceData.productGenderPriceComponents.some(service => (service.value < 0.1 || !service.value) && service.isRemainingValue) && !this.getProductEditPriceData.isPricePerGroup;
            },  
            hasRuleGroupsAssociated() {
                const targetId = this.getProductEditPriceData.id;

                if (!this.getClonedItem) {
                    return false;
                }

                return this.getClonedItem.groups.some(item => {
                    // Checks if productGenderPrices is an array and contains the gender price ID
                    const idFound = Array.isArray(item.productGenderPrices) && 
                                    item.productGenderPrices.some(genderPrice => genderPrice.id === targetId);
                    
                    // If the ID was found, it checks if productGroupPriceGroups (same group) contains at least one valid rule group
                    if (idFound) {
                        return Array.isArray(item.productGroupPriceGroups) && 
                               item.productGroupPriceGroups.some(group => group.isDeleted === false);
                    }
                    
                    return false;
                });
            },
            types() {
                const selectedComponentRuleType = this.hasRuleGroupsAssociated || this.isPricePerGroup ? 
                    [
                        { value: 1, description: 'Percent' },
                        { value: 2, description: 'Open' }
                    ] : 
                    [
                        { value: 0, description: 'Fixed' },
                        { value: 1, description: 'Percent' },
                        { value: 2, description: 'Open' }
                    ];

                // Extracts the component rule type from the product data
                const { componentRuleType } = this.getProductEditPriceData;

                // Defines the type of audience description based on the conditions
                if (this.hasRuleGroupsAssociated) {
                    this.descriptionAudienceTypes = selectedComponentRuleType.find(type => type.value === componentRuleType) || null;
                } else {
                    const defaultType = componentRuleType == null ? 0 : componentRuleType;
                    this.descriptionAudienceTypes = selectedComponentRuleType.find(type => type.value === defaultType) || null;
                }

                return selectedComponentRuleType;
            },
            isLoading() {
                return this.isLoadingExtras || this.isLoadingAudienceTypes
            },
            taxes() {
                return this.getVatTypes
            },
            totalPVP() {
                let total = 0;

                if (this.getProductEditPriceData.componentRuleType == 0) {
                    for (let service of this.getProductEditPriceData.productGenderPriceComponents) {
                        if (service.component.selectedPrice) {
                            total += service.component.selectedPrice.grossprice;
                        }
                    }

                    return (total).toFixed(2).replace(".", ",");
                }
                else {
                    let totalPrice = this.getProductEditPriceData.value ? parseFloat(this.getProductEditPriceData.value) : 0;

                    return (totalPrice).toFixed(2).replace(".", ",");
                }
            },
        },
        asyncComputed: {
            async extras() {
                try {
                    this.isLoadingExtras = true;
                    let response = await axios.get('/api/inventory/ListExtra', { params: { supplierId: this.account.supplierId }});

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        this.isLoadingExtras = false;

                        return response.data;
                    }
                }
                catch (error) {
                    this.isLoadingExtras = false;
                    this.$toasted.error(error);
                }
            },
            async audienceTypes() {
                try {
                    this.isLoadingAudienceTypes = true;
                    let response = await axios.get('/api/settings/GetAudienceTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        this.isLoadingAudienceTypes = false;
                        
                        return response.data;
                    }
                }
                catch (error) {
                    this.isLoadingAudienceTypes = false;
                    this.$toasted.error(error);
                }
            },
        },
        components: {
            Modal,
            vSelect: extendedVSelect,
            SplitPriceEditor,
            Loader,
        }
    }
</script>

<style lang="scss" scoped>
    input {
        background-color:#f5f8fa;
    }
    
    .total-value {
        font-size: 3rem;
    }

    .total-price-min-height {
        min-height: 5.8rem;
    }
</style>



// WEBPACK FOOTER //
// ProductEditPrice.vue?119d65ae